module.exports = __webpack_public_path__ + "assets/images/clap-1f0833639cc6fbb9fd43df59be82472f.png";